import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/canteen/group",
        component: List,
        name: "canteen.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/group/create",
        component: Create,
        name: "canteen.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/group/:id/edit",
        component: Edit,
        name: "canteen.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
